import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound, Send } from "lucide-react";
import { toast } from "sonner";

// Contraseña de un solo uso (enviada al email de la clínica) para ver los datos bancarios 10 minutos.
export const SepaOtpDialog = ({ open, onOpenChange, patientId, onUnlocked }) => {
    const [sentTo, setSentTo] = useState("");
    const [code, setCode] = useState("");
    const [busy, setBusy] = useState(false);
    useEffect(() => { if (open) { setSentTo(""); setCode(""); } }, [open]);

    const send = async () => {
        setBusy(true);
        try { const { data } = await api.post(`/patients/${patientId}/sepa/otp`); setSentTo(data.sent_to); toast.success(`Contraseña enviada a ${data.sent_to}`); }
        catch (e) { toast.error(e.response?.data?.detail || "No se pudo enviar la contraseña"); }
        finally { setBusy(false); }
    };
    const verify = async () => {
        setBusy(true);
        try {
            const { data } = await api.post(`/patients/${patientId}/sepa/otp/verify`, { code: code.trim() });
            onUnlocked(data.unlock_token, data.expires_at); onOpenChange(false);
        } catch (e) { toast.error(e.response?.data?.detail || "Contraseña incorrecta"); }
        finally { setBusy(false); }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md" data-testid="sepa-otp-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2"><KeyRound size={16} /> Ver datos bancarios</DialogTitle>
                    <DialogDescription>Enviaremos una contraseña de un solo uso al email de la clínica. Los datos quedarán visibles 10 minutos.</DialogDescription>
                </DialogHeader>
                {!sentTo ? (
                    <Button className="btn-cta w-full" onClick={send} disabled={busy} data-testid="sepa-otp-send"><Send size={14} className="mr-1" /> {busy ? "Enviando…" : "Enviar contraseña"}</Button>
                ) : (
                    <div className="space-y-2">
                        <p className="text-xs text-muted-foreground" data-testid="sepa-otp-sent">Enviada a {sentTo}. Caduca en 10 minutos.</p>
                        <Input inputMode="numeric" maxLength={6} placeholder="Código de 6 cifras" value={code}
                            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="font-mono tracking-[0.4em] text-center text-lg" data-testid="sepa-otp-code" />
                    </div>
                )}
                {sentTo && (
                    <DialogFooter className="gap-2">
                        <Button variant="ghost" onClick={send} disabled={busy} data-testid="sepa-otp-resend">Reenviar</Button>
                        <Button className="btn-cta" onClick={verify} disabled={busy || code.length !== 6} data-testid="sepa-otp-verify">Ver datos</Button>
                    </DialogFooter>
                )}
            </DialogContent>
        </Dialog>
    );
};
